import { render } from "./stronaPrywatnosc.vue?vue&type=template&id=2cba1e94&scoped=true"
const script = {}

import "./stronaPrywatnosc.vue?vue&type=style&index=0&id=2cba1e94&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cba1e94"]])

export default __exports__